import React, { useState, useEffect } from 'react';
import { Card, ListGroup, Spinner, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';

/**
 * Article History Component
 * Shows list of previously generated articles
 */
const ArticleHistory = () => {
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [pagination, setPagination] = useState(null);

  useEffect(() => {
    fetchHistory();
  }, [page]);

  const fetchHistory = async () => {
    try {
      const response = await fetch(`/api/tools/articles/history?page=${page}&limit=20`);
      const data = await response.json();
      setArticles(data.articles);
      setPagination(data.pagination);
      setLoading(false);
    } catch (err) {
      console.error('Error fetching history:', err);
      setLoading(false);
    }
  };

  const truncateTitle = (title, maxLength = 60) => {
    if (!title) return 'Untitled';
    if (title.length <= maxLength) return title;
    return title.substring(0, maxLength) + '...';
  };

  const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    });
  };

  if (loading) {
    return (
      <div className="text-center py-4">
        <Spinner animation="border" size="sm" />
      </div>
    );
  }

  if (articles.length === 0) {
    return null; // Don't show empty state
  }

  return (
    <Card>
      <Card.Header>
        <h5 className="mb-0">Recently Generated</h5>
      </Card.Header>
      <ListGroup variant="flush">
        {articles.map((article) => (
          <ListGroup.Item
            key={article.id}
            as={Link}
            to={`/tools/article-to-media/${article.slug}`}
            action
            style={{ textDecoration: 'none' }}
          >
            <div className="d-flex justify-content-between align-items-center">
              <div>
                <div style={{ fontWeight: '500' }}>
                  {truncateTitle(article.article_title)}
                </div>
                <small className="text-muted">
                  {article.source_domain} • {formatDate(article.completed_at)}
                </small>
              </div>
              <span style={{ color: '#6c757d' }}>→</span>
            </div>
          </ListGroup.Item>
        ))}
      </ListGroup>

      {pagination && pagination.totalPages > 1 && (
        <Card.Footer className="d-flex justify-content-between align-items-center">
          <small className="text-muted">
            Page {pagination.page} of {pagination.totalPages} ({pagination.total} total)
          </small>
          <div className="d-flex gap-2">
            <Button
              variant="outline-secondary"
              size="sm"
              disabled={page === 1}
              onClick={() => setPage(p => p - 1)}
            >
              Previous
            </Button>
            <Button
              variant="outline-secondary"
              size="sm"
              disabled={page === pagination.totalPages}
              onClick={() => setPage(p => p + 1)}
            >
              Next
            </Button>
          </div>
        </Card.Footer>
      )}
    </Card>
  );
};

export default ArticleHistory;
